// extracted by mini-css-extract-plugin
export var container = "TourPrices-module--container--yVgvd";
export var priceItem = "TourPrices-module--priceItem--1_7Qc";
export var countText = "TourPrices-module--countText--3xtJE";
export var category = "TourPrices-module--category--1i5EG";
export var totalPrice = "TourPrices-module--totalPrice--3_aaf";
export var noWrap = "TourPrices-module--noWrap--1a69L";